import axios from 'axios'

const BASE = (import.meta.env.VITE_API_URL as string) ?? ''

const RT_KEY = 'prv_rt'

let _access: string | null = null

const isBrowser = typeof window !== 'undefined'

export function setTokens(access: string, refresh: string) {
  _access = access
  if (isBrowser) localStorage.setItem(RT_KEY, refresh)
}

export function clearTokens() {
  _access = null
  if (isBrowser) localStorage.removeItem(RT_KEY)
}

export function storedRefreshToken(): string | null {
  if (!isBrowser) return null
  return localStorage.getItem(RT_KEY)
}

export const api = axios.create({ baseURL: BASE })

api.interceptors.request.use((cfg) => {
  if (_access) cfg.headers.Authorization = `Bearer ${_access}`
  return cfg
})

let refreshing = false
const queue: Array<(token: string) => void> = []

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config

    const url = (orig?.url as string) ?? ''
    const skipRefresh =
      url.includes('/auth/') || url.includes('/transfers/claim')
    if (err.response?.status !== 401 || orig?._retry || skipRefresh)
      return Promise.reject(err)

    const rt = storedRefreshToken()
    if (!rt) {
      clearTokens()
      if (isBrowser) window.location.replace('/login')
      return Promise.reject(err)
    }

    if (refreshing) {
      return new Promise((resolve) =>
        queue.push((tok) => {
          orig.headers.Authorization = `Bearer ${tok}`
          resolve(api(orig))
        }),
      )
    }

    orig._retry = true
    refreshing = true

    try {
      const { data } = await axios.post<{
        accessToken: string
        refreshToken: string
      }>(`${BASE}/auth/refresh`, { refreshToken: rt })
      setTokens(data.accessToken, data.refreshToken)
      queue.splice(0).forEach((cb) => cb(data.accessToken))
      orig.headers.Authorization = `Bearer ${data.accessToken}`
      return api(orig)
    } catch {
      clearTokens()
      queue.splice(0)
      if (isBrowser) window.location.replace('/login')
      return Promise.reject(err)
    } finally {
      refreshing = false
    }
  },
)
